export default __webpack_public_path__ + "static/media/Auto_3.dce0a2bc.JPG";